module.exports = __webpack_public_path__ + "media/images/athletes/1540-f2c61d2a650298ea83999c5a241d2763.png";